import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useWaiterStore } from '../store/waiterStore';

export const ClientProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { client } = useWaiterStore();

  if (!client) {
    return (
      <div className="text-center py-16">
        <p className="text-slate-400">Клиент не найден</p>
        <button
          onClick={() => navigate('/waiter/scan')}
          className="mt-4 px-6 py-2 bg-emerald-600 text-white rounded-xl"
        >
          Сканировать QR
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <button
        onClick={() => navigate('/waiter/scan')}
        className="flex items-center text-slate-400 hover:text-white transition-colors"
      >
        <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Назад
      </button>

      {/* Client card */}
      <div className="bg-slate-800/60 backdrop-blur-lg rounded-2xl border border-slate-700/50 p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-16 h-16 rounded-full bg-emerald-600/20 border border-emerald-500/30 flex items-center justify-center">
            <span className="text-emerald-400 text-xl font-bold">
              {client.name.split(' ').map(w => w[0]).join('').slice(0, 2)}
            </span>
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">{client.name}</h2>
            <p className="text-slate-400">{client.phone || `ID: ${client.id}`}</p>
          </div>
        </div>

        {/* Bonus balance */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-slate-700/30 rounded-xl p-4">
            <p className="text-slate-400 text-sm">Баланс бонусов</p>
            <p className="text-2xl font-bold text-white">{client.bonusBalance}</p>
          </div>
          <div className="bg-slate-700/30 rounded-xl p-4">
            <p className="text-slate-400 text-sm">Доступно</p>
            <p className="text-2xl font-bold text-emerald-400">{client.effectiveBalance}</p>
          </div>
        </div>
      </div>

      {/* Action button */}
      <button
        onClick={() => navigate(`/waiter/menu/${client.id}`)}
        className="w-full py-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold text-lg transition-colors flex items-center justify-center space-x-2"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
        <span>Открыть меню</span>
      </button>
    </div>
  );
};
